import {SDTKAddress} from './address.model';

export class SDTKProposer {
  proposer_type = '';
  company_name = '';
  trading_name: string = '';
  micro_enterprise: boolean = null;
  year: number = null;
  address: any = new SDTKAddress();
  is_phone = 0;
  sms = 0;
  is_email = 0;
  post = 0;
  first_name :string= '';
  last_name:string = '';
  email:string = '';
}
